import React from "react";
import { CherryHubDataApi } from "../../api/dataApiModels";
import { ServiceManagementFeatures } from "../../enums/ServiceManagementFeatures";
import { ConfigurationDetail } from "../../pages/Environments/ConfigurationDetail";
import { EnvironmentDetail } from "../Environment/EnvironmentDetail";
import { ListView } from "../ListView/ListView";
import { OutboundIpDetails } from "../OutboundIpDetails/OutboundIpDetails";
import {
  Accordion,
  AccordionButton,
  AccordionIcon,
  AccordionItem,
  AccordionPanel,
  Box,
  Text,
} from "@chakra-ui/react";
import { ListViewDictionary } from "../ListView/ListViewDictionary";

interface IntegrationFeatureResultProps {
  name: ServiceManagementFeatures;
  result: any;
}

export const IntegrationFeatureResult = ({
  name,
  result,
}: IntegrationFeatureResultProps) => {
  switch (name) {
    case ServiceManagementFeatures.GetServiceOutboundIpDetails:
      return (
        <OutboundIpDetails
          outbound={result as [key: string]}
          isLoading={false}
        />
      );

    case ServiceManagementFeatures.GetServiceApiEnvironmentDetails:
      return (
        <EnvironmentDetail
          env={result as CherryHubDataApi.Environment}
          isLoading={false}
        />
      );

    case ServiceManagementFeatures.GetServiceConfigurationValues:
      return (
        <ConfigurationDetail
          config={result as CherryHubDataApi.Configurations}
        />
      );

    case ServiceManagementFeatures.GetIntegrationWorkerList:
    case ServiceManagementFeatures.GetIntegrationWorkerListTypes:
    case ServiceManagementFeatures.GetIntegrationMMSList:
    case ServiceManagementFeatures.GetIntegrationMMSListTypes:
    case ServiceManagementFeatures.GetIntegrationSecretConfiguration:
      return <ListView list={result} />;

    case ServiceManagementFeatures.GetIntegrationWorkerListAll:
    case ServiceManagementFeatures.GetIntegrationMMSListAll: {
      let list = result as { [key: string]: any };
      return (
        <Accordion allowToggle>
          {(Object.keys(list).length &&
            Object.entries(list).map(([key, value], idx) => (
              <AccordionItem key={idx}>
                {({ isExpanded }) => (
                  <>
                    <h2>
                      <AccordionButton
                        _expanded={{ bg: "cherryButtonDark", color: "grey" }}
                      >
                        <Box flex="1" textAlign="left">
                          {key}
                        </Box>
                        <AccordionIcon />
                      </AccordionButton>
                    </h2>
                    <AccordionPanel width="100%">
                      {isExpanded && <ListView list={value} />}
                    </AccordionPanel>
                  </>
                )}
              </AccordionItem>
            ))) || <Text fontStyle="italic">List is empty</Text>}
        </Accordion>
      );
    }

    case ServiceManagementFeatures.PerformIntegrationMMSConnectionTest:
    case ServiceManagementFeatures.GetIntegrationMMSConnectionStatus:
    case ServiceManagementFeatures.PerformIntegrationMLSConnectionTest:
    case ServiceManagementFeatures.GetIntegrationMLSConnectionStatus:
    case ServiceManagementFeatures.PerformIntegrationWorkerStart:
    case ServiceManagementFeatures.GetIntegrationWorkerStatus:
    case ServiceManagementFeatures.GetIntegrationWorkerStatusAll:
    case ServiceManagementFeatures.GetServiceManagementMetadata:
      return <ListViewDictionary dictionary={result} />;

    case ServiceManagementFeatures.PerformIntegrationMLSConnectionClose:
    case ServiceManagementFeatures.PerformIntegrationMMSConnectionClose:
      return (
        <Text>{(result as CherryHubDataApi.ScalarValue)?.Value as string}</Text>
      );

    case ServiceManagementFeatures.PerformIntegrationWorkerStop:
      return (
        <Text>
          {result == true ? "Success" : result == false ? "Failed" : "-"}
        </Text>
      );

    case ServiceManagementFeatures.BootstrapIntegrationConfiguration:
      return (
        <Text>
          {typeof result === "string" ? result : JSON.stringify(result)}
        </Text>
      );

    default:
      return <></>;
  }
};
